import { useAuth } from "react-oidc-context";
import { Navigate, useLocation } from "react-router";
import { getDevicesUrl } from "@/Utils/EnvUtils";
import { AppSelector } from "./login/AppSelector";
import MedicalCircleIcon from "@medoma/components/icons/MedicalCircleIcon";
import NotebookPenIcon from "@medoma/components/icons/NotebookPenIcon";
import SmartPhoneIcon from "@medoma/components/icons/SmartPhoneIcon";
import MedicalBriefcaseIcon from "@medoma/components/icons/MedicalBriefcaseIcon";
import { useUserProfile } from "@/api/Users";
import { useFeatureFlag } from "@/api/FeatureFlags";
import { knownFeatureFlagsSchema } from "@/api/FeatureFlags";
import { useLingui } from "@lingui/react/macro";
import { useSelectedSite } from "@/Utils/useSelectedSite";

const AuthenticatedIndex = () => {
  const { t } = useLingui();
  const { organization } = useUserProfile();
  const { data: isTemplateManagementModuleEnabled } = useFeatureFlag(
    knownFeatureFlagsSchema.enum.FE_TemplateManagementModuleEnabled,
  );
  const { data: isEquipmentManagementEnabled } = useFeatureFlag(
    knownFeatureFlagsSchema.enum.FE_EquipmentManagement,
  );
  const selectedSite = useSelectedSite();
  if (!selectedSite) {
    throw new Error("Should have selected site when showing app selector");
  }

  const centerApp = {
    icon: <MedicalCircleIcon />,
    label: t`Center`,
    description: t`Planering och samordning`,
    to: "/commandcenter",
  };

  const goLoginHelperRoute = {
    icon: <SmartPhoneIcon />,
    label: t`Inloggning medarbetare`,
    description: t`Hantera inloggning för medarbetare i Go`,
    to: getDevicesUrl(organization, selectedSite),
  };

  const templateManagerRoute = {
    icon: <NotebookPenIcon />,
    label: t`Aktivitetsmallar`,
    description: t`Hantera mallar för att skapa aktiviteter`,
    to: "/template-manager",
  };

  const equipmentManagementRoute = {
    icon: <MedicalBriefcaseIcon />,
    label: t`Utrustning`,
    description: t`Hantera utrustning`,
    to: "/equipment-management",
  };

  const secondaryApps = [
    goLoginHelperRoute,
    ...(isTemplateManagementModuleEnabled ? [templateManagerRoute] : []),
    ...(isEquipmentManagementEnabled ? [equipmentManagementRoute] : []),
  ];

  return <AppSelector primary={centerApp} secondary={secondaryApps} />;
};

const Index = () => {
  const location = useLocation();
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <AuthenticatedIndex />;
};

export default Index;
